import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	createProcess,
	deleteProcess,
	editProcess,
	editProcessConnection,
	getProcessConnection,
	getProcesses,
	uploadDocument,
} from "./stepTwo.thunks";

interface StepTwoState {
	processList: any[];
	selectedProcess: any;
	showOnlyCritical: boolean;
	processConnection: any[];
	status: string | null;
}

const initialState: StepTwoState = {
	processList: [],
	selectedProcess: {},
	showOnlyCritical: false,
	processConnection: [],
	status: null,
};

const stepTwoSlice = createSlice({
	name: "stepTwoSlice",
	initialState,
	reducers: {
		ChangeDisplayCriticality(state, action: PayloadAction<boolean>) {
			state.showOnlyCritical = action.payload;
		},
		ClearProcessConnection(state, action: PayloadAction) {
			state.processConnection = [];
		},
		ChangeStatus(state, action: PayloadAction<string | null>) {
			state.status = action.payload;
		},
		resetStep_2_1: () => initialState,
	},
	extraReducers: (builder) => {
		builder.addCase(getProcesses.fulfilled, (state, action: PayloadAction<any>) => {
			state.processList = action.payload;
		});
		builder.addCase(createProcess.fulfilled, (state, action: PayloadAction<any>) => {
			state.processList.push(action.payload);
			state.status = null;
		});
		builder.addCase(editProcess.fulfilled, (state, action: PayloadAction<any>) => {
			const processIndex: number = state.processList.findIndex((process) => process.id === action.payload.id);
			state.processList[processIndex] = action.payload;
			state.status = null;
		});
		builder.addCase(deleteProcess.fulfilled, (state, action: PayloadAction<any>) => {
			state.processList = state.processList.filter((process) => process.id !== action.payload);
			state.status = null;
		});
		builder.addCase(getProcessConnection.fulfilled, (state, action: PayloadAction<any[]>) => {
			state.processConnection = action.payload;
		});
		builder.addCase(editProcessConnection.fulfilled, (state, action: PayloadAction<any>) => {
			const objectIndex: number = state.processList.findIndex((process) => process.id === action.payload.id);
			state.processList[objectIndex] = action.payload;
		});
		builder.addCase(uploadDocument.fulfilled, (state) => {
			state.status = new Date().toISOString().split("T")[0];
		});
	},
});

export const { ChangeDisplayCriticality, ClearProcessConnection, ChangeStatus, resetStep_2_1 } = stepTwoSlice.actions;
export default stepTwoSlice.reducer;
